(() => {
if (window.ProdigioComparison) { window.ProdigioComparison.scan(); return; }
const instances = new Map();
function initProdigioComparison(element) {
  if (instances.has(element)) return;
  const wrapper = element.querySelector('[data-comparison-slider]');
  const input = element.querySelector('input[type="range"]');
  if (!wrapper || !input) return;
  const abort = new AbortController();
  const options = { signal: abort.signal };
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  let raf = 0, timer = 0, visible = false, held = false, keyHeld = false;
  let until = 0, phase = 0, last = 0;
  input.setAttribute('aria-label', 'Confronta prima e dopo');
  input.step = '0.1';
  const labels = document.createElement('div');
  labels.className = 'prodigio-comparison-labels';
  labels.innerHTML = '<span>PRIMA</span><span>DOPO</span>';
  element.prepend(labels);
  const mask = document.createElement('div');
  mask.className = 'prodigio-comparison-mask';
  mask.setAttribute('aria-hidden', 'true');
  wrapper.append(mask);
  function set(value) {
    wrapper.style.setProperty('--compare', String(value));
    input.value = String(value);
    wrapper.dataset.prodigioPosition = value.toFixed(2);
  }
  function stop() { cancelAnimationFrame(raf); raf = 0; last = 0; }
  function allowed() { return element.isConnected && visible && !document.hidden && !motion.matches && !held && !keyHeld && performance.now() >= until; }
  function tick(now) {
    raf = 0;
    if (!element.isConnected) { cleanup(); return; }
    if (!allowed()) { last = 0; return; }
    if (last) phase += (now - last) * 2 * Math.PI / 8000;
    last = now;
    set(50 - 40 * Math.cos(phase));
    raf = requestAnimationFrame(tick);
  }
  function resume() {
    stop(); clearTimeout(timer);
    if (motion.matches) { if (!held && !keyHeld) set(50); return; }
    if (performance.now() < until) { timer = setTimeout(resume, until - performance.now() + 10); return; }
    if (allowed()) raf = requestAnimationFrame(tick);
  }
  function pause() { stop(); clearTimeout(timer); }
  function release() {
    const value = Math.max(10, Math.min(90, Number(input.value)));
    phase = Math.acos((50 - value) / 40);
    until = performance.now() + 5000;
    pause(); timer = setTimeout(resume, 5010);
  }
  input.addEventListener('pointerdown', () => { held = true; pause(); }, options);
  window.addEventListener('pointerup', () => { if (held) { held = false; release(); } }, options);
  window.addEventListener('pointercancel', () => { if (held) { held = false; release(); } }, options);
  input.addEventListener('input', () => { set(Number(input.value)); if (!held && !keyHeld) release(); }, options);
  const rangeKeys = new Set(['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'PageUp', 'PageDown']);
  input.addEventListener('keydown', event => { if (rangeKeys.has(event.key)) { keyHeld = true; pause(); } }, options);
  window.addEventListener('keyup', event => { if (rangeKeys.has(event.key) && keyHeld) { keyHeld = false; release(); } }, options);
  input.addEventListener('blur', () => { if (keyHeld) { keyHeld = false; release(); } }, options);
  window.addEventListener('blur', () => { if (held || keyHeld) { held = false; keyHeld = false; release(); } }, options);
  document.addEventListener('visibilitychange', resume, options);
  motion.addEventListener('change', resume, options);
  const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; resume(); }, { threshold: 0.05 });
  function cleanup() { stop(); clearTimeout(timer); abort.abort(); observer.disconnect(); labels.remove(); mask.remove(); instances.delete(element); }
  instances.set(element, cleanup);
  wrapper.dataset.prodigioAuto = 'ready';
  set(motion.matches ? 50 : 10);
  wrapper.style.setProperty('--transition-duration', '0s');
  observer.observe(element);
}
function destroyProdigioComparison(element) { instances.get(element)?.(); }
function scan() {
  for (const element of instances.keys()) if (!element.isConnected) destroyProdigioComparison(element);
  document.querySelectorAll('[data-prodigio-comparison]').forEach(initProdigioComparison);
}
window.ProdigioComparison = { init: initProdigioComparison, destroy: destroyProdigioComparison, scan };
document.addEventListener('shopify:section:load', scan);
document.addEventListener('shopify:section:unload', event => {
  event.target.querySelectorAll('[data-prodigio-comparison]').forEach(destroyProdigioComparison);
});
new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
else scan();
})();
